module.exports = __webpack_public_path__ + "static/project_mobile-c423f7a4318e7bc2257e9f81f7b2a913.png";